import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";

const bg = require("../../images/background/bg3.png");

class Footer extends Component {
  render() {
    const { t } = this.props;

    return (
      <>
        <footer className="site-footer">
          <div className="footer-top" style={{ backgroundImage: `url(${bg})` }}>
            <div className="container">
              <div className="row">
                <div className="col-md-3 col-5 col-xl-2 col-lg-2 col-sm-6 footer-col-4">
                  <div className="widget widget_services border-0">
                    <h5 className="footer-title text-white">
                      {t("footer.usefulLinks")}
                    </h5>
                    <ul>
                      <li>
                        <Link to="/contact">{t("footer.contact")}</Link>
                      </li>
                      <li>
                        <Link to="/about">{t("footer.services")}</Link>
                      </li>
                      <li>
                        <Link to="/products">{t("footer.products")}</Link>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="col-md-6 col-xl-4 col-lg-3 col-sm-6 footer-col-4">
                  <div className="widget widget_getintuch">
                    <h5 className="footer-title text-white">
                      {t("footer.contactUs")}
                    </h5>
                    <ul>
                      <li>
                        <i className="ti-location-pin"></i>
                        <strong>{t("footer.addressLabel")}:</strong>{" "}
                        {t("footer.address")}
                      </li>
                      <li>
                        <i className="ti-mobile"></i>
                        <strong>{t("footer.phoneLabel")}:</strong>{" "}
                        {t("footer.phone")}
                      </li>
                      <li>
                        <i className="ti-email"></i>
                        <strong>{t("footer.emailLabel")}:</strong>{" "}
                        {t("footer.email")}
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="col-md-12 col-xl-4 col-lg-4 col-sm-6 footer-col-4"></div>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-sm-6 text-left">
                  <span>{t("footer.designedBy")}</span>
                </div>
                <div className="col-md-6 col-sm-6 text-right">
                  <div className="widget-link">
                    <ul>
                      <li>
                        <Link to="/about-2">{t("footer.about")}</Link>
                      </li>
                      <li>
                        <Link to="/help-desk">{t("footer.helpDesk")}</Link>
                      </li>
                      <li>
                        <Link to="/privacy-policy">
                          {t("footer.privacyPolicy")}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </>
    );
  }
}

export default withTranslation()(Footer);
